import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { bool, shape, number, string } = proptypes;
import { StoreMap } from '@thd-olt-component-react/store-map';
import { StoreSearchContext } from '../StoreSearch.context';

export const Map = ({ mapOptions }) => {
  let mapOptionsMerged = { ...StoreMap.defaultProps.mapOptions, ...mapOptions };

  const {
    setSearchCoordinates,
    setHighlightedStoreId,
    stores
  } = useContext(StoreSearchContext);

  const handleStoreClick = (store) => {
    setHighlightedStoreId(store?.storeId);
  };

  const handleOnMapViewChange = (centerOfMap) => {
    const { latitude, longitude } = centerOfMap || {};
    setSearchCoordinates({
      lat: latitude,
      lng: longitude
    });
  };

  return (
    <StoreMap
      mapOptions={mapOptionsMerged}
      omitStoreNumber={mapOptionsMerged?.omitStoreNumber}
      onMapViewChange={mapOptionsMerged?.disableOnMapViewChange ? () => { } : handleOnMapViewChange}
      onStoreClick={mapOptionsMerged?.disableOnStoreClick ? () => { } : handleStoreClick}
      stores={stores}
    />
  );
};

Map.propTypes = {
  mapOptions: shape({
    disableInfoBox: bool,
    disableOnMapViewChange: bool,
    disableOnStoreClick: bool,
    disablePanning: bool,
    disableScrollWheelZoom: bool,
    height: string,
    showDashboard: bool,
    omitStoreNumber: string,
    zoom: number,
  })
};

Map.defaultProps = {
  mapOptions: {
    disableInfoBox: false,
    disableOnMapViewChange: false,
    disableOnStoreClick: false,
    disablePanning: false,
    disableScrollWheelZoom: false,
    height: '800px',
    showDashboard: true,
    omitStoreNumber: '',
    zoom: 10,
  }
};

Map.displayName = 'Map';
